// extracted by mini-css-extract-plugin
export default {"judgesLogin-view":"index_judgesLogin-view__pRb2u"};